import type { ReactNode } from 'react'

interface Props {
  title: string
  description: string
  children?: ReactNode
}

export const TabHeader = ({ title, description, children }: Props) => (
  <div className="flex flex-wrap items-start justify-between gap-x-4 gap-y-2">
    <div className="flex flex-col gap-0.5">
      <h5 className="font-medium text-heading-foreground text-lg">{title}</h5>
      <p className="max-w-[50ch] text-sm">{description}</p>
    </div>
    {children && <div className="ml-auto">{children}</div>}
  </div>
)
